/**
 * Утилиты для работы с DOM
 */

/**
 * Показывает ошибку валидации для поля формы
 * @param {HTMLElement} input - Поле ввода
 * @param {string} message - Сообщение об ошибке
 */
export function showFormError(input, message) {
  if (!input || !input.parentNode) return

  // Удаляем предыдущую ошибку
  hideFormError(input)

  // Добавляем класс ошибки
  input.classList.add('form__input--error')

  // Создаем элемент с ошибкой
  const errorMessage = document.createElement('div')
  errorMessage.className = 'form__error'
  errorMessage.textContent = message
  errorMessage.setAttribute('role', 'alert')
  errorMessage.setAttribute('aria-live', 'polite')

  input.parentNode.appendChild(errorMessage)
}

/**
 * Скрывает ошибку валидации для поля формы
 * @param {HTMLElement} input - Поле ввода
 */
export function hideFormError(input) {
  if (!input || !input.parentNode) return

  input.classList.remove('form__input--error')

  const existingError = input.parentNode.querySelector('.form__error')
  if (existingError) {
    existingError.remove()
  }
}

/**
 * Проверяет виден ли элемент в viewport
 * @param {HTMLElement} element - Элемент для проверки
 * @param {number} offset - Отступ от края экрана
 * @returns {boolean} - true если элемент виден
 */
export function isElementInViewport(element, offset = 100) {
  if (!element) return false

  const rect = element.getBoundingClientRect()
  return (
    rect.top >= -offset &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

/**
 * Плавная прокрутка к элементу
 * @param {HTMLElement|string} target - Элемент или селектор
 * @param {number} offset - Отступ от верха
 * @param {string} behavior - Поведение прокрутки ('smooth' | 'auto')
 */
export function scrollToElement(target, offset = 0, behavior = 'smooth') {
  const element = typeof target === 'string' ? document.querySelector(target) : target
  if (!element) return

  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
  const offsetPosition = elementPosition - offset

  window.scrollTo({
    top: offsetPosition,
    behavior,
  })
}




